export const dayJSLangResolver = (lang: string) => {
    if (lang === "en_US") {
        return "en";
    }
    if (lang === "ja_JP") {
        return "ja";
    }
    return lang.replace("_", "-").toLocaleLowerCase();
};
